import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, ButtonBase, FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';
import Helpers from '../../helpers/helpers';


export default function CustomSelectMultiple({
    values, style, onChange, error, data, title, required, disabled, placeholder, subtitle, readOnly, name, valueName, labelName, width, height, noBorderRadius
}) {
    const handleDeleteFromValue = async (idx) => {
        let splicedArr = values;
        await splicedArr.splice(idx, 1);
        onChange(splicedArr);
    }
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    return (
        <>
            <FormControl variant="outlined" fullWidth={width ? false : true} error={error ? true : false}>
                {/* {title && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, color: "#434343" }}>{title}</FormLabel>} */}
                <Select
                    size="small"
                    value={values}
                    name={name}
                    error={error ? true : false}
                    required={required}
                    disabled={disabled}
                    multiple
                    displayEmpty
                    MenuProps={MenuProps}
                    placeholder={placeholder || 'Choose'}
                    inputProps={{
                        sx: {
                            '&::placeholder': {
                                color: '#BDBDBD',
                                opacity: 1,
                            },
                            paddingInline: 2.5
                        },
                    }}
                    onChange={(e) => { onChange(e.target.value) }}
                    sx={{
                        backgroundColor: disabled ? "#f1f3f4" : "inherit",
                        minHeight: height ? height : "49px",
                        '.MuiOutlinedInput-notchedOutline': {
                            border: "none",
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            border: "none",
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#E6E6E6',
                        },
                    }}
                    style={{
                        backgroundColor: disabled ? "#f1f3f4" : "white",
                        color: (values === "" || values === "-1") ? "#c8c8c8" : 'inherit',
                        width: width && width,
                        minHeight: height ? height : "57px",
                        borderRadius: (noBorderRadius && 0) || 12,
                        marginTop: "7px",
                        border: '1.5px solid #E6E6E6',
                        paddingBlock: 5,

                    }}
                    IconComponent={() => (
                        <i className="ri-arrow-down-s-line me-2" style={{ color: '#1D1B1B' }}></i>
                    )}
                    renderValue={(selected) => {
                        if (!selected || selected.length === 0) {
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', }}>
                                    <span style={{
                                        fontSize: 12,
                                        color: disabled ? '#C0C0C0' : '#808588',
                                        fontWeight: 500,
                                        marginBottom: 2
                                    }}>
                                        {title}
                                    </span>
                                    <span style={{ color: '#DDDDDD' }}>
                                        {placeholder || 'Choose'}
                                    </span>
                                </div>

                            );
                        } else
                            return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }} onClick={(e) => e.stopPropagation()}>
                                    {values && !Helpers?.isArrayNullOrEmpty(values) && values?.length > 0 && values?.map((value, idx) => (
                                        <div key={value} className='d-flex justify-content-between' style={{ color: '#434343', paddingInline: 10, paddingBlock: 3, backgroundColor: '#FFFFFF', borderRadius: 15, border: '1px solid #E2E2E2' }} >
                                            <div>
                                                {data?.filter((x) => (x?.value || x?.id || x[`${valueName}`]) === value)[0]?.label ||
                                                    data?.filter((x) => (x.value || x.id || x[`${valueName}`]) === value)[0]?.name ||
                                                    data.filter((x) => (x.value || x.id || x[`${valueName}`]) === value)[0]?.[`${labelName}`]}
                                            </div>
                                            <ButtonBase style={{ marginLeft: 7 }} onMouseDown={(event) => { event.stopPropagation(); handleDeleteFromValue(idx) }}>
                                                <Icon icon="ri:close-fill" style={{ color: '#525252' }} />
                                            </ButtonBase>
                                        </div>
                                    ))}
                                </Box>
                            );
                    }}
                >
                    {
                        data && data.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx} value={x?.value || x?.id || x[`${valueName}`]} style={{ backgroundColor: values?.includes(x?.value || x?.id || x[`${valueName}`]) ? '#FDECEC' : 'white', }}>
                                {x?.label || x?.name || x?.[`${labelName}`]}
                            </MenuItem>
                        ) : <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl >
            {error && <FormHelperText className='d-flex align-items-center' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error || ""}</FormHelperText>
            }
        </>
    );
}
